import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Returns the public origin the admin portal should use when it
 * builds shareable user-facing links (e.g. `/p/:slug`, `/dashboard`).
 *
 *   1. If `VITE_USER_FACING_ORIGIN` is set at build time (recommended
 *      in production: `https://merryflix.com`), use that.
 *   2. Otherwise in the browser, fall back to the current admin
 *      origin. This means dev / preview builds still produce
 *      copy-able links, but production should always set the env.
 */
export function userFacingOrigin(): string {
  const env = (import.meta.env.VITE_USER_FACING_ORIGIN as string | undefined)?.trim();
  if (env) return env.replace(/\/$/, '');
  if (typeof window !== 'undefined') return window.location.origin;
  return '';
}

/**
 * Build a full, copy-pasteable URL to a public proposal on the
 * user-facing web app.
 */
export function publicProposalUrl(slug: string): string {
  const origin = userFacingOrigin();
  return `${origin}/p/${slug}`;
}